import { DateFormatEnum as e } from "../types/date-time-format.js";
import { LanguageCodeEnum as t } from "@systemeio/types";
//#region src/date-picker/utils/date-utils.ts
var n = (e, n) => new Date(new Intl.DateTimeFormat(t.ENGLISH, {
	day: "2-digit",
	hour: "numeric",
	minute: "numeric",
	month: "2-digit",
	second: "numeric",
	timeZone: n,
	year: "numeric"
}).format(e)), r = (e, t) => e ? e instanceof Date ? n(e, t) : e.match(/([-+]\d+:?\d+)$/) ? n(new Date(e), t) : new Date(e) : n(/* @__PURE__ */ new Date(), t), i = (e, t) => r(e, t), a = (e) => {
	let t = (e) => `${e}`.padStart(2, "0");
	return `${e.getFullYear()}-${t(e.getMonth() + 1)}-${t(e.getDate())}T${t(e.getHours())}:${t(e.getMinutes())}:${t(e.getSeconds())}`;
}, o = (t) => {
	switch (t) {
		case e.dateFirst: return "en-GB";
		case e.monthFirst: return "en-US";
		default: return;
	}
}, s = (e, t) => (typeof e == "string" ? new Date(e) : e).toLocaleString(o(t?.dateFormat), {
	day: "2-digit",
	month: "2-digit",
	timeZone: t?.timeZone,
	year: "numeric"
});
//#endregion
export { s as formatDate, i as getDate, r as setDateWithTimezone, a as toISOStringWithoutTimezone };
